import { memo, useContext } from "react";
import { Button, Box, Stack, Icon, Typography } from "@mui/material";
import BottomDialog from "./BottomDialog.js";
import { AuthContext } from "src/utils/AuthContext.js";
import ShareDialog from "src/components/blocks/dialogs/ShareDialog.js";
import CalendarSelect from "../CalendarSelect.js";

const TimelineCreatorDialog = ({
  open,
  calendars,
  handle,
  selectedCalendar,
  setSelectedCalendar,
  openEditEventDialog,
  setOpenEditEventDialog,
}) => {
  const { user } = useContext(AuthContext);

  // Filter calendars to only show those with automatedIds
  const automatedCalendars =
    calendars?.filter((calendar) => calendar.automatedId) || [];

  const BottomDialogSx = {
    height: "121px",
    ".MuiDialogContent-root": { padding: "0px" },
    ".MuiDialogTitle-root": { margin: "auto" },
  };

  return (
    <BottomDialog
      open={open && !openEditEventDialog}
      hideCloseButton
      hideRectangle
      handleClose={() => {}}
      sx={BottomDialogSx}
      dialogTitle={
        <CalendarSelect
          setSelectedCalendar={setSelectedCalendar}
          user={user}
          selectedCalendar={selectedCalendar}
          calendars={automatedCalendars}
          size="md"
          checkSubscriptionStatus={false}
        />
      }
      disableScrollLock
      hideBackdrop
    >
      <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            fontSize: "inherit",
            backgroundColor: "#000000",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#333333",
            },
          }}
          onClick={() => {
            setOpenEditEventDialog(true);
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Icon
              baseClassName="material-symbols-outlined"
              fontSize="small"
              sx={{
                color: "#ffffff",
              }}
            >
              add
            </Icon>
            <Typography variant="subtitle1" color="#ffffff">
              CREATE EVENT
            </Typography>
          </Box>
        </Button>
        <ShareDialog
          calendar={selectedCalendar}
          handle={handle}
          as="IconButton"
        />
      </Stack>
    </BottomDialog>
  );
};

export default memo(TimelineCreatorDialog, (prevProps, nextProps) => {
  return (
    prevProps.open === nextProps.open &&
    prevProps.handle === nextProps.handle &&
    prevProps.openEditEventDialog === nextProps.openEditEventDialog &&
    prevProps.selectedCalendar?._id === nextProps.selectedCalendar?._id
  );
});
